import React, { Component } from 'react';

import { ViewContext } from '@helpers/contexts';
import viewport from '@helpers/viewport';

class SmoothScroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scroll: 0,
      init: false,
    };
  }

  componentDidMount() {
    if (!this.props.viewport.mobileView) {
      this.init();
    }
  }

  componentDidUpdate() {
    if (!this.props.viewport.mobileView && !this.state.init) {
      this.init();
    } else if (this.props.viewport.mobileView && this.state.init) {
      this.reset();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  init = () => {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
    this.setState({ init: true });
  };

  reset = () => {
    window.removeEventListener('scroll', this.handleScroll);

    this.setState({
      scroll: 0,
      init: false,
    });
  };

  handleScroll = () => {
    const scroll =
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      window.pageYOffset;
    this.setState({ scroll });
  };

  render() {
    const { viewport } = this.props;
    const { scroll } = this.state;

    return (
      <ViewContext.Provider
        value={{
          scroll,
          windowWidth: viewport.width,
          windowHeight: viewport.height,
          mobileView: viewport.mobileView,
        }}
      >
        {this.props.children}
      </ViewContext.Provider>
    );
  }
}

export default viewport(SmoothScroll);
